import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../joylogo.png';
/*import { MdDns } from "react-icons/md";*/
import Icon from '@mdi/react';
import {mdiAccessPoint} from '@mdi/js';
import {mdiTelevisionClassic } from '@mdi/js';
import {mdiPodcast } from '@mdi/js';
import {mdiPlayCircleOutline } from '@mdi/js';
import { mdiMagnify } from '@mdi/js';
import Search from './search';

function TopBar(){

    const formstyle = {position: "fixed", top: "50px", zIndex: "999"};

    const [searchlabel, setSearchlabel] = useState(false);
    const [searchterm,setSearchterm] = useState("");
    const [sresult,setSresult] = useState("");
   
  
    
    

    const handlesearch = (e) =>{

        e.preventDefault()
        setSresult(searchterm)
            
        }
    
        const searctm = (e) =>{
            setSearchterm(e.target.value)
            setSresult(searchterm)
        }

return(
 <>
 <div className={searchlabel? "showelement searchoverlay":"hideelement"} onClick={()=>setSearchlabel(false)}></div>
<div className="container zero-padding" style={{float: "left",position: "fixed", zIndex: "5"}}>
    
    <div className="top-nav">
        
    <Link to="/" className="show-mobile"><img src={logo} width="50px" alt="Site Logo "/></Link>
    <Link to={{pathname:"/livetv", state:{vdurl:"https://www.dailymotion.com/embed/video/x7w7197"}}}><Icon path={mdiTelevisionClassic} size={1} horizontal vertical rotate={180} color="#fff" /><span className="hide-mobile sp-pos">TV</span></Link>
    <Link to={{pathname:"/radio", state:{stationurl:"https://sgplayer.streamguys1.com/atunwa/myjoyonline/mgl/joyfm/embed.min.js?v=3.1.0c", name:"JoyFm"}}}><Icon path={mdiAccessPoint} size={1} horizontal vertical rotate={180} color="#fff" />
    <span className="hide-mobile sp-pos">Radio</span></Link>
    <Link to={{pathname:"/podcast"}}><Icon path={mdiPodcast} size={1} horizontal vertical rotate={180} color="#fff" /><span className="hide-mobile sp-pos">Podcast</span></Link>
    <Link to={{pathname:"/videos"}}><Icon path={mdiPlayCircleOutline} size={1} horizontal vertical rotate={180} color="#fff" /><span className="hide-mobile sp-pos">Videos</span></Link>
    <a  onClick={()=>setSearchlabel(true)}><Icon path={mdiMagnify} size={1} horizontal vertical rotate={180} className="hide-mobile" color="#fff" style={{background:"none !important"}} /></a>
    
    </div>
    </div> 
    <form onSubmit={handlesearch}  style={formstyle} className={searchlabel ? "showelement hide-mobile":"hideelement hide-mobile"}>
                       <input type="text" placeholder='search' onClick={()=>setSearchlabel(true)} className={searchlabel?"searchinput searchinputshow":"searchinput"} onChange={searctm} value={searchterm} /> 
            </form>
           <div style={{maxWidth: "556px", position: "fixed", zIndex: "800", left: "29%", top: "66px"}}>
            { <Search search={ sresult } hideshow={ searchlabel } /> }
            </div>
            <div>

                        </div>
            
</>
    
);
}

export default TopBar;